import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import Wonders from '@/roc/wonders';
import { useLayoutStore } from "@/roc/stores/LayoutStore";
export const useWonderStore = defineStore('Wonders', () => {
    const lytStore = useLayoutStore();
    const wonders = ref({});
    const configuringWonders = ref(false);
    const wonderMap = {};
    for (let i = 0; i < Wonders.length; i++) {
        wonderMap[Wonders[i].id] = {
            ...Wonders[i]
        };
        wonders.value[Wonders[i].id] = {
            id: Wonders[i].id,
            level: 1,
            active: false
        };
    }
    return {
        // state
        wonders,
        configuringWonders,
        wonderMap,
        // getters
        activeWonderCount: computed(() => {
            let r = 0;
            for (const i in wonders.value) {
                if (wonders.value[i].active) {
                    r++;
                }
            }
            return r;
        }),
        // actions
        openWonderConfiguration() {
            configuringWonders.value = true;
        },
        closeWonderConfiguration() {
            configuringWonders.value = false;
        },
        setWonderConfiguration(config) {
            wonders.value = {
                ...config
            };
            lytStore.applyWonderBonuses();
        },
        loadWonderConfiguration(wonderList) {
            for (let i = 0; i < wonderList.length; i++) {
                wonders.value[wonderList[i].id] = {
                    ...wonderList[i]
                };
            }
        },
        mapWonders(callback) {
            for (const i in wonders.value) {
                if (callback(wonderMap[wonders.value[i].id], wonders.value[i]) === false) {
                    return;
                }
            }
        },
    };
});
